import jsPDF from 'jspdf';

const PDFGeneratorServiceFn = {
    generatePDF: (data, title) => {
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text(title, 10, 10);

        let y = 20;
        data.forEach((item, index) => {
            doc.setFontSize(14);
            doc.text(`Intervenção ${index + 1}`, 10, y);

            y += 10;
            Object.entries(item).forEach(([key, value]) => {
                if (key === 'Fotos' && Array.isArray(value)) {
                    doc.setFontSize(12);
                    doc.text('Fotos:', 10, y);
                    y += 10;

                    value.forEach((photo, photoIndex) => {
                        // Assuming `photo` is a base64 image string (e.g., "data:image/png;base64,...")
                        if (typeof photo === 'string') {
                            try {
                                doc.addImage(photo, 'JPEG', 10, y, 50, 50); // Adjust dimensions as needed
                                y += 60; // Space between images
                            } catch (err) {
                                console.error(`Error adding image ${photoIndex + 1}:`, err);
                                doc.setFontSize(10);
                                doc.text(`Erro ao adicionar a imagem ${photoIndex + 1}`, 10, y);
                                y += 10;
                            }
                        }
                    });
                } else {
                    doc.setFontSize(12);
                    doc.text(`${key}: ${Array.isArray(value) ? value.join(', ') : value}`, 10, y);
                    y += 10;
                }
            });

            y += 10; // Space between interventions
        });

        doc.save(`${title}.pdf`);
    },
};

export default PDFGeneratorServiceFn;
